import { Container, Stack } from '@mantine/core';
import BreadcrumbsComponent from 'components/BreadcrumbsComponent';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import MasterPlanDetail from 'modules/pages/dacum/masterPlan/MasterPlanDetail';
import MasterPlanDetailByGroup from 'modules/pages/dacum/reviewMasterplan/MasterPlanDetailByGroup';
import { useSearchParams } from 'react-router-dom';
import { pathnames } from 'routes/dacum';

const MasterPlanDetailPage = () => {
  const [searchParams] = useSearchParams();
  const jobFamily = searchParams.get('jobfamily') || '';
  const jobFamilyGroup = searchParams.get('jobFamilyGroup') || '';
  const year = searchParams.get('year') || '';
  const endYear = searchParams.get('endYear') || '';
  const { appName } = useAppName();
  const pageContent = PAGES[appName]?.reviewMasterPlan;

  const breadcrumbs = [
    { title: 'Review Masterplan', href: pathnames.reviewMasterPlan },
    { title: 'Master Plan Detail', href: '' }
  ];

  // Determine which component to render based on URL parameters
  const renderDetail = () => {
    if (jobFamilyGroup) {
      // Use the new grouped detail view
      return (
        <MasterPlanDetailByGroup jobFamilyGroup={jobFamilyGroup} year={year} endYear={endYear} />
      );
    } else if (jobFamily) {
      // Use the original detail view (for backward compatibility)
      return <MasterPlanDetail jobFamily={jobFamily} year={year} />;
    }
    return null;
  };

  return (
    <Container fluid>
      <Stack>
        <BreadcrumbsComponent items={breadcrumbs} mb={16} />
        <PageTitle
          title={pageContent?.title ? `${pageContent.title} - Detail` : 'Master Plan Detail'}
          description={pageContent?.description || ''}
        />
        {renderDetail()}
      </Stack>
    </Container>
  );
};

export default MasterPlanDetailPage;
